import { useEffect, useRef, useState } from "react";

interface UseAgentFeedScrollInput {
  feedItemCount: number;
  streamingLength: number;
  isStreaming: boolean;
}

export function useAgentFeedScroll({
  feedItemCount,
  streamingLength,
  isStreaming,
}: UseAgentFeedScrollInput) {
  const bottomRef = useRef<HTMLDivElement>(null);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const userAtBottomRef = useRef(true);
  const [showScrollDown, setShowScrollDown] = useState(false);

  useEffect(() => {
    const element = scrollContainerRef.current;
    if (!element) return;

    const handleScroll = () => {
      const atBottom = element.scrollHeight - element.scrollTop - element.clientHeight < 80;
      userAtBottomRef.current = atBottom;
      setShowScrollDown(!atBottom);
    };

    element.addEventListener("scroll", handleScroll, { passive: true });
    return () => element.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!isStreaming && !userAtBottomRef.current) return;
    const behavior = isStreaming ? "smooth" : "instant";
    bottomRef.current?.scrollIntoView({ behavior: behavior as ScrollBehavior });
  }, [feedItemCount, streamingLength, isStreaming]);

  return {
    bottomRef,
    scrollContainerRef,
    showScrollDown,
  };
}
